import { render, staticRenderFns } from "./fieldCheckboxB4.vue?vue&type=template&id=51060ebc&"
import script from "./fieldCheckboxB4.vue?vue&type=script&lang=js&"
export * from "./fieldCheckboxB4.vue?vue&type=script&lang=js&"
import style0 from "./fieldCheckboxB4.vue?vue&type=style&index=0&id=51060ebc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports